<script>

export const sideDrawer = {
  topNavHeight:"92px",
  outerClasses:"side-nav-drawer"
}

export const navbar = {

  //optional. if it will shrink on scroll
  scrollShrink: true, //false,

  subitemsRevealDuration: 0,

  //the mergeable classes for the outer fixed wrapper
  outerContainerClassesDesktop: "fbicc-nav-outer",
  outerContainerClassesMobile: "fbicc-nav-outer",

  backgroundColor: "var(--nav-main-color1)",
  shrinkColor:"var(--nav-main-color1)",
  backgroundProperty:"background-color",

  logoWrapperClasses:"fbicc-logo-wrapper",

  hamburgerButtonClasses:"fbicc-hamburger-button",

  //the logo and aria text
  logoSrc:"/cms-static-assets/2026/04/Bidwell-Logo.jpg",
  logoAriaAlt:"FBICC navigation logo",

  desktopLayout:"banner",

  banner: {
    hasRightArea:false,
    hasLeftLogoArea:true,
    navAreaClasses:{ override:"sb sb-v" },
    topAreaClasses:{ override:"sb sb-v sb-greedy" },
    //topAreaClasses:"sb-content-space-between sb-align-2bottom sb-alt2"
  },

  //required
  height: "150px",
  shrinkHeight: "50px",


  padding: "14px",
  shrinkPadding: "5px",

  //optional. The top gap
  topGap: "0px"
    
}

export default { "name":"themenavbar" }

</script>

<style>

/**
 * Sidedrawer
 */
.side-nav-drawer {
  background: linear-gradient(180deg,var(--sidenav-grad-start-color ) 0%, var(--sidenav-grad-end-color) 100%);
  opacity: 1;
}

/*********************  

Navbar CSS 

***********************/

.navbar-outer-container--attop {
  background-image:url('/cms-static-assets/2026/04/FF335584-29D3-45D5-BBC7-D2A1D148466FL0001-xsizes-1024.jpg') !important;
  background-position: 50% 60% !important;
  background-size: cover !important;
  background-repeat: no-repeat !important;
}

@media (min-width:1400px) {
 .navbar-outer-container--attop {
    background-image:url('/cms-static-assets/2026/04/FF335584-29D3-45D5-BBC7-D2A1D148466FL0001-xsizes-1024.jpg');
    background-position: 50% 55%;
    background-size: cover;
    background-repeat: no-repeat;
  } 
}

.navbar-outer-container--attop::before {
  content:"";
  position:absolute;
  left:0; 
  right:0;
  top:0;
  bottom:0;
  background-color:rgba(59, 58, 103, 0.5)
  /*
  background: linear-gradient(180deg,rgba(59, 58, 103, 0) 40%, rgba(59, 58, 103, 1) 90%);
   */

}

.navbar-inner-container {
  max-width:1200px;
}


/* Add --attop options for the nav item style */
.nav-top-option {
  cursor: pointer;
  z-index: 2;
  color: white !important;
  font-size: 1.2rem;
  font-weight: 700;
  white-space: nowrap;
  text-decoration: none;
  padding-left:20px;
  padding-right:20px;
}

.nav-top-option:hover {
  background-color:var(--nav-main-color2);  
}
.nav-dropdown-item:hover {
  background-color:var(--nav-main-color2);
}



a.nav-top-option.router-link-exact-active {
  color: white;
}

.navbar-banner-top-area {
  padding-left:20px;
  padding-top:20px;
}
.navbar-banner-top-area h1 {
  font-size:1.8rem;
  color:#FFFFFF !important;
  text-shadow: 2px 2px 3px rgba(33, 51, 84, 0.9);
}
.navbar-banner-top-area h2 {
  font-size:1.2rem;
  color:#FFFFFF !important;
  margin-top:2px;
}

.navbar-subitems > .sb {
  background: var(--nav-main-color2);
  color: #FFFFFF;
  padding: 5px 15px 5px 15px;
  font-weight: normal;
}

.fbicc-navbar-dropdown-option:hover {
  background: var(--nav-main-color1);
}

.fbicc-top-nav-routes-subitems {
  width: 300px !important;
}
.fbicc-top-nav-routes-subitems > a {
  font-size: 1rem !important;
  padding: 10px !important;
  font-weight: bold !important;
  text-decoration: none !important;
}




/* 
add --attop behavior for the nav area. We're going to 
shift it over and up so that it's one line */
.navbar-banner-nav-area {
  padding-right: 20px;
  background-color: var(--nav-main-color1);
}
.navbar-banner-nav-area.navbar-banner-nav-area--attop {
  padding-right: 20px;
  margin-top:10px;
}

.navbar-banner-top-area {
  display:none;
}
.navbar-banner-top-area.navbar-banner-top-area--attop {
  display:flex;
}

.fbicc-nav-main-searchoption {
  width: 100px !important;
}
.fbicc-nav-main-search-iconbutton {
  width: 80px !important;
}
.fbicc-nav-main-search-widget-button {
  width: 100px !important;
}

.portal-link {
  background-color: var(--portal-main-color);
  color: #ffffff !important;
  border-radius: 3px;
  border: 1px solid var(--portal-border-color);
  transition: all .2s linear;
  text-decoration: none;
  padding:15px;
}
.portal-link:hover {
  background-color:var(--portal-hover-color)
}

.fbicc-hamburger-button {
  border-top: 4px solid white !important;
  border-bottom: 4px solid white !important;
}
.fbicc-hamburger-button::after {
  background: white !important;
}

</style>

